<template>
  <div class="top_icon_area">
    <TopIcon
      v-for="(icon, key) in icons"
      :key="key"
      :icon="icon"
      class="icon"
    ></TopIcon>
  </div>
</template>

<script>
import TopIcon from '@/components/atoms/TopIcon.vue';

export default {
  components: {
    TopIcon,
  },

  data: () => ({
    icons: [
      {
        image: '/img/icons/gacha24.png',
        url: 'https://wanana.iranoan.com/',
        text: 'Gacha24',
        target: 'blank',
      },
      {
        image: '/img/icons/gachamo.png',
        url: 'https://gachamo.com/',
        text: 'Gachamo',
        target: 'blank',
      },
      {
        image: '/img/icons/hoppy.png',
        url: 'https://hoppy-gacha-iranoan.com/',
        text: 'Hoppy',
        target: 'blank',
      },
      {
        image: '/img/icons/yuly.png',
        url: 'https://yugioh.only.iranoan.com/',
        text: 'Yuly',
        target: 'blank',
      },
      {
        image: '/img/icons/keeps.png',
        url: 'https://ws.iranoan.com/',
        text: 'keepβ',
        target: 'blank',
      },
      {
        image: '/img/icons/gachaichi.png',
        url: 'https://main.gachaichi.jp/',
        text: 'Gachaichi',
        target: 'blank',
      },
      {
        image: '/img/icons/gachaichi_town.png',
        url: 'https://gachaichi.jp/town/',
        text: 'GachaichiTown',
        target: 'blank',
      },
      {
        image: '/img/icons/point_exchange.png',
        url: 'https://minny-online-store.iranoan.com/contacts?service=1',
        text: 'Point Transfer',
        target: 'blank',
      },
      {
        image: '/img/icons/card_coin.png',
        url: '/exchange-card',
        text: 'Exchange counter',
        target: '',
      },
      {
        image: '/img/icons/friend.png',
        url: '/change-member',
        text: 'Referral of a Friend',
        target: '',
      },
      {
        image: '/img/icons/melpay.png',
        url: '/buy-point',
        text: 'minny online store',
        target: '',
      },
      // {
      //   image: '/img/icons/company_profile.png',
      //   url: 'https://iranoan.site/',
      //   text: 'Our Company',
      // },
      {
        image: '/img/icons/purchase_table.png',
        url: 'https://minny-online-store.iranoan.com',
        text: 'Purchase List',
        target: 'blank',
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.top_icon_area {
  display: flex;
  flex-wrap: wrap;
  max-width: 1080px;
  justify-content: center;
  margin: auto;
  .icon {
    margin: 10px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .top_icon_area {
    max-width: 360px;
    width: 100%;
    .icon {
      margin: 8px;
    }
  }
}
</style>
